<template>
  <b-row>
    <b-col sm="12">
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading
            :module-id="access.module_id"
            :profile-id="access.profile_id"
            :reference="access.view_reference"
            summary-only
          />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions"><TabHeaderActions /></div>
          </div>
        </section>
      </b-card>
      
      <b-row>
        <b-col sm="6">          
          <b-card>
            <FullCalendar defaultView="dayGridMonth"
                          :plugins="calendarPlugins"
                          :locale="calendarOptions.locale"
                          :weekends="true"
                          :events="calendarOptions.event"
                          :selectable="true"
                          :titleFormat="calendarTitleFormat"
                          @dateClick="dateClick "/>
          </b-card>                                      
        </b-col>
        <b-col sm="6">

          <b-card>
            <b-row class="mb-3">
              <b-col md="12">
                <h4 class="detail-hours-month-title">{{ formatMonthTitle(dateSelected) }}</h4>
              </b-col>              
            </b-row>
            <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-dark">
              <b-tab>
                <template #title><AppIcon name="description" class="mr-1" /> General</template>
                <b-row align-h="center">
                  <b-col md="8">
                    <div class="app-modal-detail-list">
                      <div class="app-modal-detail-list__row">
                        <span class="app-modal-detail-list__label">Proyectos</span>
                        <span class="app-modal-detail-list__value">{{ total.hoursProjectMonth.toFixed(2) }} Hs</span>
                      </div>
                      <div class="app-modal-detail-list__row">
                        <span class="app-modal-detail-list__label">Actividades</span>
                        <span class="app-modal-detail-list__value">{{ total.hoursActivityMonth.toFixed(2) }} Hs</span>
                      </div>
                      <div class="app-modal-detail-list__row">
                        <span class="app-modal-detail-list__label"><b>Total trabajado</b></span>
                        <span class="app-modal-detail-list__value"><b>{{ (total.hoursProjectMonth + total.hoursActivityMonth).toFixed(2) }} Hs</b></span>
                      </div>
                    </div>
                  </b-col>    
                </b-row>
              </b-tab>
              <b-tab>
                <template #title><AppIcon name="pie_chart" class="mr-1" /> Detalle</template>
                <b-row align-h="center">
                  <b-col md="8">
                    <PieChart
                      v-if="chart.loaded"
                      :chartData="chart.chartdata"
                    />            
                    <EmptyState v-else icon="pie_chart" title="Sin registros" description="No se encontraron datos para el mes seleccionado." />
                  </b-col>         
                </b-row>         
              </b-tab>
            </b-tabs>            
          </b-card>

          <b-card>
            <b-row class="mb-3">
              <b-col md="6">
                <h2>{{moment(this.dateSelected).format('DD')}} de 
                    {{moment(this.dateSelected).format('MMMM')}} de 
                    {{moment(this.dateSelected).format('YYYY')}}</h2>
              </b-col>              
            </b-row>
            
            <b-row>
              <b-col md="12">                        
                <b-table class="app-table app-table--compact detail-hours-table"
                        responsive
                        :stacked="isMobileViewport ? 'md' : false"
                        sticky-header="60vh"
                        :hover="true"
                        :small="true"
                        :fixed="false"
                        :items="table.items"
                        :fields="table.fields"
                        v-if="table.items.length">
                    
                    <template v-slot:table-colgroup="scope">
                      <col
                        v-for="field in scope.fields"                    
                        :key="field.key"
                        :style="{ width: isMobileViewport ? 'auto' : field.width }"
                      >
                    </template>  

                    <template v-slot:cell(assignment)="data">
                      <div v-if="data.item.projects_id" class="detail-hours-assignment detail-hours-assignment--project">
                        <AppIcon name="business_center" class="detail-hours-assignment__icon" />
                        <div class="detail-hours-assignment__content">
                          <b>{{ data.item.projects.name }}</b>
                          <span>{{ data.item.projects.customer.name }}</span>
                        </div>
                      </div>                      
                      <div v-else class="detail-hours-assignment detail-hours-assignment--activity">
                        <AppIcon name="task_alt" class="detail-hours-assignment__icon" />
                        <div class="detail-hours-assignment__content"><b>{{ data.item.activity.name }}</b></div>
                      </div>                                                                  
                    </template>
                  
                    <template v-slot:cell(description)="data">
                      <div class="text-wrap">
                        {{ data.item.description }}
                      </div>
                    </template>

                    <template v-slot:cell(hours)="data">
                      <b>{{ data.item.hours }} hs</b>
                    </template>

                </b-table>
                <EmptyState v-else icon="history" title="No se encontraron registros" description="No hay horas cargadas para el día seleccionado." />
              </b-col>
            </b-row>            

            <b-row class="mt-3" align-h="center" v-if="table.items.length">              
              <b-col md="12">
                <div class="app-modal-detail-list">
                  <div class="app-modal-detail-list__row">
                    <span class="app-modal-detail-list__label">Proyectos</span>
                    <span class="app-modal-detail-list__value">{{ totalProjects.toFixed(2) }} Hs</span>
                  </div>
                  <div class="app-modal-detail-list__row">
                    <span class="app-modal-detail-list__label">Actividades</span>
                    <span class="app-modal-detail-list__value">{{ totalActivity.toFixed(2) }} Hs</span>
                  </div>
                  <div class="app-modal-detail-list__row">
                    <span class="app-modal-detail-list__label"><b>Total trabajado</b></span>
                    <span class="app-modal-detail-list__value"><b>{{ (totalActivity + totalProjects).toFixed(2) }} Hs</b></span>
                  </div>
                </div>
              </b-col>              
            </b-row>                
          </b-card> 
                        
          <b-card body-class="py-2">
            <div class="list-view-footer">
              <div>
                <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
                  <AppIcon name="arrow_back" class="mr-1" />
                  Volver
                </b-button>                        
              </div>
            </div>
          </b-card>                    
        </b-col>
      </b-row>              
    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Profiles from '@/config/profiles'
  import Error from '@/handler/error'
  import ErrorToken from '@/handler/errorToken'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper' 
  import Theme from '@/config/theme'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'
  import moment from 'moment'   
  import PieChart from './chart/pie'    
  import {EventBus} from '@/handler/event-bus'

  import FullCalendar from '@fullcalendar/vue'
  import dayGridPlugin from '@fullcalendar/daygrid'    
  import esLocale from '@fullcalendar/core/locales/es';
  import interactionPlugin from '@fullcalendar/interaction';

  export default {
    components: {                
      FullCalendar,
      PieChart,
      TabHeaderActions,
    },        
    data: () => {
      return {      
        access: {
          module_id: Modules.EMPLEADOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'detailEmployeeHours',
          elements: {}
        }, 
        calendarPlugins: [ dayGridPlugin, interactionPlugin ],        
        calendarOptions: {
          locale: esLocale,
          event: []
        },
        table : {
          items: [],
          fields: [],
        }, 
        isMobileViewport: false,
        mobileMql: null,
        total: {
          hoursProjectMonth: 0,
          hoursActivityMonth: 0,
        },
        dateSelected: moment().format('YYYY-MM-DD') ,       
        employeeSelectedID: 0,
        employeeSelected: {},
        chart: {
          loaded: false,
          chartdata: {},
        }, 
        detailMonthsEmployee: [],
      }
    },
    created () {     
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    }, 
    watch: {
      detailMonthsEmployee: function() {
        this.loadChartEmployee()
      },
    }, 
    mounted () {      
      this.employeeSelectedID = this.$route.params.employeeID  

      moment.locale('es');
      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)
      this.setFields()
      this.loadEmployeeSelected()        
    },      
    beforeDestroy() {
      if(this.mobileMql) {
        this.mobileMql.removeEventListener('change', this.updateMobileViewport)
      }
    },
    computed: {
      totalActivity: function() {
        var total = 0
        this.table.items.forEach(element => {
          if(element.activity_id) {
            total = total + parseFloat(element.hours)
          }          
        }) 
        return total       
      },       
      totalProjects: function() {
        var total = 0
        this.table.items.forEach(element => {
          if(element.projects_id) {
            total = total + parseFloat(element.hours)
          }          
        }) 
        return total       
      },      
    },
    methods: {
      setFields() {
        this.table.fields = [
          {key: 'assignment', label: 'Asignación', class: 'align-middle', width: '25%'},
          {key: 'description', label: 'Detalle', class: 'align-middle', width: '55%'},
          {key: 'hours', label: 'Horas', class: 'align-middle ' + this.alignClass('text-center'), width: '20%'},
        ]
      },
      alignClass(desktopClass) {
        return this.isMobileViewport ? 'text-left' : desktopClass
      },
      updateMobileViewport(e) {
        this.isMobileViewport = e.matches
        this.setFields()
      },
      chartColor(index) {
        // Un gráfico es una de las excepciones del sistema: cada serie
        // necesita un color propio y la leyenda explica su significado.
        // El ángulo áureo reparte los tonos sin repetirlos entre proyectos.
        var hue = (index * 137.508) % 360
        return 'hsl(' + hue.toFixed(1) + ', 58%, 42%)'
      },
      setMetaTitle(title) {
        EventBus.$emit('Update:TabTitle', 'Empleado: ' + title)
      },
      // El titleFormat automático del locale es.js arma "enero de 2026" (el
      // "de" es gramática española correcta para esa combinación, no un
      // error del locale) -- queremos solo "Enero 2026", así que se arma a
      // mano en vez de dejarle el formateo por defecto a FullCalendar.
      //
      // moment.utc(), NO moment(): arg.date.marker está en el dominio UTC
      // (medianoche UTC = 1° del mes) sin importar el timezone real; leerlo
      // con moment() local lo corre un mes atrás en husos negativos (ej.
      // Argentina UTC-3: "Julio" en vez de "Agosto").
      calendarTitleFormat(arg) {
        var text = moment.utc(arg.date.marker).format('MMMM YYYY')
        return text.charAt(0).toUpperCase() + text.slice(1)
      },
      formatMonthTitle(date) {
        var text = moment(date).format('MMMM YYYY')
        return text.charAt(0).toUpperCase() + text.slice(1)
      },
      dateClick(date) { 
        this.dateSelected = date.dateStr                 
        this.getHours()        
      },
      loadCalendar() {   
        let loader = this.$loading.show();

        this.calendarOptions.event = []

        var data = {          
          staff_id: this.employeeSelected.staff_id          
        }
        var result = serviceAPI.obtenerHorasByEmployee(data)

        result.then((response) => {                    
          var data = response.data

          data.projects.forEach(element => {
            var event = {}

            event = {
              title: 'Proyectos: ' + element.hours + ' hs',
              start: element.date,
              // Los eventos de día completo usan end exclusivo en FullCalendar.
              allDay: true,
              end: moment(element.date).add(1, 'day').format('YYYY-MM-DD'),
              color: Theme.getColor(Theme.TOKENS.successHover, '#185f3f'),
              textColor: '#ffffff',
            }            
            this.calendarOptions.event.push(event)            
          }); 
          
          data.activity.forEach(element => {
            var event = {}

            event = {
              title: 'Actividades: ' + element.hours + ' hs',
              start: element.date,
              allDay: true,
              end: moment(element.date).add(1, 'day').format('YYYY-MM-DD'),
              color: Theme.getColor(Theme.TOKENS.warningHover, '#854c00'),
              textColor: '#ffffff',
            }            
            this.calendarOptions.event.push(event)            
          });         

          loader.hide()
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error))
        });                     
      },
      getHours() {
        this.getHoursByDay()
        this.getHoursByMonth()        
      },
      getHoursByDay() {
        let loader = this.$loading.show();
        var data = {
          staff_id: this.employeeSelected.staff_id,
          date: this.dateSelected 
        }              
        var result = serviceAPI.obtenerHorasByDia(data)

        result.then((response) => {                    
          var data = response.data
          
          this.table.items = data   
                              
          loader.hide()
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error))
        });
      }, 
      getHoursByMonth() {
        let loader = this.$loading.show();
        var data = {
          staff_id: this.employeeSelected.staff_id,
          date: this.dateSelected
        }              
        var result = serviceAPI.obtenerHorasByMes(data)

        result.then((response) => {                    
          var data = response.data
          this.detailMonthsEmployee = data          
          
          var totalProjects = 0
          var totalActivity = 0
          data.forEach(element => {            
            if(element.projects_id) {
              totalProjects = totalProjects + parseFloat(element.hours)
            } else {
              totalActivity = totalActivity + parseFloat(element.hours)
            }
          });

          this.total.hoursProjectMonth = totalProjects
          this.total.hoursActivityMonth = totalActivity
                    
          loader.hide()
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error))
        });
      },       
      loadEmployeeSelected(){
        let loader = this.$loading.show();
        var result = serviceAPI.mostrarEmpleado(this.employeeSelectedID)

        result.then((response) => {                            
          var data = response.data                            
          this.employeeSelected = data    
          
          this.loadCalendar()
          this.getHours()

          this.setMetaTitle(this.employeeSelected.name)
          
          loader.hide()
        }) 
        .catch(error => {       
          loader.hide()   
          this.$awn.alert(ErrorToken.valid(error));
        }) 
      },

      loadChartEmployee() {     
        var data = this.formatDataChart()

        if(data.length) {                    
          var labels = []
          var datasets = [{
            backgroundColor: [],
            data: []
          }]          
                    
          data.forEach((item, index)=>{
            datasets[0].data.push(parseFloat(item.hours))
            datasets[0].backgroundColor.push(this.chartColor(index))
            
            if(item.activity_id) {
              labels.push('ACTIVIDAD:' + item.activityName)
            } else {
              labels.push('PROYECTO:' + item.projectsName)
            }                      
          })
          
          this.chart.chartdata = {
            labels: labels,
            datasets: datasets,          
          }

          this.chart.loaded = true
        } else {
          this.chart.loaded = false            
        }                         
      },
      formatDataChart() {
        var arrData = []
        var data = this.detailMonthsEmployee
                
        if(data) {          
          data.forEach(element => {            
            let key = ''
            if(element.activity_id) {
              key = 'A' + element.activity_id
            } else {
              key = 'P' + element.projects_id
            }

            if(arrData.hasOwnProperty(key)) {
              arrData[key].hours = arrData[key].hours + parseFloat(element.hours)
            } else {              
              arrData[key] = []
              arrData[key] = {
                hours: parseFloat(element.hours),
                activity_id: element.activity_id,
                projects_id: element.projects_id,
                projectsName: (element.projects ? element.projects.name : ''),
                activityName: (element.activity ? element.activity.name : ''),
              }                
            }
                          
          });
        }
        
        var arrTMP = []
        for (const prop in arrData) {
          arrTMP.push(arrData[prop])
        }               

        return arrTMP
      }
    }
  }
</script>
<style scoped>
  .detail-hours-month-title {
    margin: 0;
    font-size: 21px;
    font-weight: var(--app-font-semibold, 600);
  }

  .detail-hours-assignment {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .detail-hours-assignment__icon {
    flex: 0 0 auto;
  }

  .detail-hours-assignment--project .detail-hours-assignment__icon {
    color: var(--app-color-success);
  }

  .detail-hours-assignment--activity .detail-hours-assignment__icon {
    color: var(--app-color-warning);
  }

  .detail-hours-assignment__content {
    display: flex;
    min-width: 0;
    flex-direction: column;
  }

  .detail-hours-assignment__content span {
    display: block;
    overflow: hidden;
    color: var(--app-color-text-secondary);
    font-size: var(--app-text-xs, 11px);
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
